/*
 * Product detail page — gallery slider (+ arrows), image zoom, variant
 * selection, quantity, description clamp, and "you may also like" slider.
 * - Main Swiper + synced thumbnail Swiper (Thumbs) + prev/next arrows.
 * - Touch: Swiper Zoom (pinch / double-tap).
 * - Desktop (hover-capable, non-touch): Drift hover-magnify into a large pane.
 * Inert unless [data-pdp] exists.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  function initGallery() {
    var mainEl = root.querySelector('[data-pdp-main]');
    if (!mainEl || typeof Swiper === 'undefined') return null;

    var thumbsEl = root.querySelector('[data-pdp-thumbs]');
    var isLeft = root.querySelector('.pdp-gallery.lg\\:flex-row-reverse') !== null;
    var prevEl = root.querySelector('[data-pdp-prev]');
    var nextEl = root.querySelector('[data-pdp-next]');
    var thumbsSwiper = null;

    if (thumbsEl) {
      // Left layout: thumbs stack vertically (a column) beside the main image on
      // desktop, and run horizontally below it on mobile. Swiper can't switch
      // `direction` via breakpoints, so resolve it up front and flip on resize.
      var lgQuery = window.matchMedia('(min-width: 1024px)');
      var thumbDirection = function () {
        return isLeft && lgQuery.matches ? 'vertical' : 'horizontal';
      };
      thumbsSwiper = new Swiper(thumbsEl, {
        direction: thumbDirection(),
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        on: {
          resize: function (sw) {
            var dir = thumbDirection();
            if (sw.params.direction !== dir) sw.changeDirection(dir);
          }
        }
      });
    }

    return new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      zoom: { maxRatio: 3 },
      navigation: prevEl && nextEl ? { prevEl: prevEl, nextEl: nextEl } : false,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined
    });
  }

  function initZoom() {
    if (root.getAttribute('data-pdp-zoom') !== 'on') return;
    if (typeof Drift === 'undefined') return;
    if (window.matchMedia('(hover: none)').matches) return; // touch → rely on Swiper zoom

    var pane = root.querySelector('[data-pdp-zoom-pane]');
    root.querySelectorAll('[data-pdp-main] img[data-zoom]').forEach(function (img) {
      /* global Drift */
      new Drift(img, {
        sourceAttribute: 'data-zoom',
        paneContainer: pane || undefined,
        inlinePane: pane ? false : true,
        zoomFactor: 2.6,
        hoverBoundingBox: false,
        handleTouch: false
      });
    });
  }

  function formatMoney(cents) {
    var currency = root.getAttribute('data-pdp-currency') || 'USD';
    var options = {
      style: 'currency',
      currency: currency
    };
    if (currency === 'USD') {
      var fractionDigits = cents % 100 === 0 ? 0 : 2;
      options.currencyDisplay = 'narrowSymbol';
      options.minimumFractionDigits = fractionDigits;
      options.maximumFractionDigits = fractionDigits;
    }
    return new Intl.NumberFormat(root.getAttribute('data-pdp-locale') || undefined, options).format(cents / 100);
  }

  function initVariants() {
    var dataEl = root.querySelector('[data-pdp-variants]');
    var idInput = root.querySelector('[data-pdp-id]');
    var groups = root.querySelectorAll('[data-pdp-option-group]');
    if (!dataEl || !idInput || !groups.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function selections() {
      var sel = [];
      groups.forEach(function (g) {
        var i = parseInt(g.getAttribute('data-pdp-option-group'), 10);
        var active = g.querySelector('[data-pdp-option][aria-pressed="true"]');
        sel[i] = active ? active.getAttribute('data-pdp-value') : null;
      });
      return sel;
    }

    function match(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      });
    }

    // Set every ATC button (main buy box + sticky bar share [data-pdp-atc]).
    function setAtc(disabled, labelAttr) {
      root.querySelectorAll('[data-pdp-atc]').forEach(function (atc) {
        atc.disabled = disabled;
        var lbl = atc.querySelector('[data-pdp-atc-label]');
        if (lbl) lbl.textContent = atc.getAttribute(labelAttr);
      });
    }

    function apply() {
      var sel = selections();
      var variant = match(sel);

      if (!variant) {
        setAtc(true, 'data-label-unavailable');
        return;
      }

      idInput.value = variant.id;

      // Both the main price and the sticky-bar price carry [data-pdp-price].
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      root.querySelectorAll('[data-pdp-price]').forEach(function (priceWrap) {
        var cur = priceWrap.querySelector('[data-pdp-current] [data-price-number]');
        if (cur) cur.textContent = formatMoney(variant.price);
        var compareWrap = priceWrap.querySelector('[data-pdp-compare]');
        if (compareWrap) {
          compareWrap.classList.toggle('hidden', !onSale);
          var cmp = compareWrap.querySelector('[data-price-number]');
          if (cmp && onSale) cmp.textContent = formatMoney(variant.compare_at_price);
        }
        var discountWrap = priceWrap.querySelector('[data-pdp-discount]');
        if (discountWrap) {
          discountWrap.classList.toggle('hidden', !onSale);
          if (onSale) {
            var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            discountWrap.textContent = pct + '% ' + (discountWrap.getAttribute('data-off-label') || 'OFF');
          }
        }
      });

      setAtc(!variant.available, variant.available ? 'data-label-add' : 'data-label-soldout');

      root.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { price: variant.price } }));

      if (variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        root.querySelectorAll('[data-pdp-sticky-image]').forEach(function (img) { img.src = src; });
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Keep the Tamara pay-later widget amount in sync with the selected variant.
      var tamara = root.querySelector('[data-pdp-tamara]');
      if (tamara) {
        tamara.setAttribute('amount', (variant.price / 100).toFixed(2));
        if (window.TamaraWidgetV2 && typeof window.TamaraWidgetV2.refresh === 'function') {
          try { window.TamaraWidgetV2.refresh(); } catch (e) {}
        }
      }

      // Keep the Tabby pay-later widget amount in sync with the selected variant.
      if (root.querySelector('[data-pdp-tabby]') && typeof window.refreshTabbyPromo === 'function') {
        try { window.refreshTabbyPromo(variant.price / 100); } catch (e) {}
      }

      if (variant.featured_media && window.__pdpMain) {
        var imgs = root.querySelectorAll('[data-pdp-main] [data-media-id]');
        for (var i = 0; i < imgs.length; i++) {
          if (String(imgs[i].getAttribute('data-media-id')) === String(variant.featured_media.id)) {
            window.__pdpMain.slideTo(i);
            break;
          }
        }
      }

      groups.forEach(function (g) {
        var i = parseInt(g.getAttribute('data-pdp-option-group'), 10);
        var selLabel = g.querySelector('[data-pdp-option-selected]');
        if (selLabel && sel[i]) selLabel.textContent = sel[i];
      });
    }

    root.querySelectorAll('[data-pdp-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-pdp-option-group]');
        group.querySelectorAll('[data-pdp-option]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        apply();
      });
    });
  }

  // Wire every quantity stepper (main buy box + sticky bar) and keep all
  // [data-pdp-qty-input] values mirrored, so the sticky qty always matches.
  function initQuantity() {
    var groups = root.querySelectorAll('[data-pdp-qty]');
    if (!groups.length) return;

    function setQty(val) {
      val = Math.max(1, val || 1);
      root.querySelectorAll('[data-pdp-qty-input]').forEach(function (i) { i.value = val; });
    }

    groups.forEach(function (wrap) {
      var input = wrap.querySelector('[data-pdp-qty-input]');
      var minus = wrap.querySelector('[data-pdp-qty-minus]');
      var plus = wrap.querySelector('[data-pdp-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) + 1); });
      if (input) input.addEventListener('change', function () { setQty(parseInt(input.value, 10) || 1); });
    });
  }

  // Quantity-discount tiers (Single / Buy 2 & Save / Buy 3 & Save): clicking a
  // row sets the qty input(s) via the same 'change' event initQuantity listens
  // on. Totals re-sync on variant change since unit price can vary by variant;
  // the qty stepper driving the input directly also re-syncs which row is active.
  function initQtyTiers() {
    var wrap = root.querySelector('[data-pdp-tiers]');
    var tiers = wrap ? wrap.querySelectorAll('[data-pdp-tier]') : [];
    if (!tiers.length) return;

    function render(unitPrice) {
      tiers.forEach(function (btn) {
        var qty = parseInt(btn.getAttribute('data-tier-qty'), 10) || 1;
        var discount = parseInt(btn.getAttribute('data-tier-discount'), 10) || 0;
        var compare = unitPrice * qty;
        var total = Math.max(compare - discount * qty, 0);
        var totalEl = btn.querySelector('[data-tier-total] [data-price-number]');
        if (totalEl) totalEl.textContent = formatMoney(total);
        var compareEl = btn.querySelector('[data-tier-compare] [data-price-number]');
        if (compareEl) compareEl.textContent = formatMoney(compare);
      });
    }

    function syncActive(qty) {
      tiers.forEach(function (btn) {
        var tierQty = parseInt(btn.getAttribute('data-tier-qty'), 10) || 1;
        btn.setAttribute('aria-pressed', String(tierQty === qty));
      });
    }

    tiers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.getAttribute('data-tier-qty'), 10) || 1;
        syncActive(qty);
        root.querySelectorAll('[data-pdp-qty-input]').forEach(function (input) {
          input.value = qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    root.querySelectorAll('[data-pdp-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncActive(parseInt(input.value, 10) || 1);
      });
    });

    root.addEventListener('pdp:variant-change', function (e) {
      render(e.detail.price);
    });
  }

  // Reveal the Read more/less toggle only when the clamped text overflows.
  function initDescription() {
    var body = root.querySelector('[data-pdp-desc-body]');
    var toggle = root.querySelector('[data-pdp-desc-toggle]');
    if (!body || !toggle) return;
    if (body.scrollHeight - body.clientHeight < 4) {
      body.classList.remove('line-clamp-[5]');
      return;
    }
    toggle.classList.remove('hidden');
    var more = toggle.querySelector('[data-more]');
    var less = toggle.querySelector('[data-less]');
    toggle.addEventListener('click', function () {
      var clamped = body.classList.toggle('line-clamp-[5]');
      if (more) more.classList.toggle('hidden', !clamped);
      if (less) less.classList.toggle('hidden', clamped);
    });
  }

  // "You may also like" — fetch the recommendations section and init its slider.
  // The response is the store's own server-rendered section; we move its parsed
  // nodes in via DOM methods (no innerHTML assignment).
  function initRecommendations() {
    var el = document.querySelector('[data-pdp-recommendations]');
    if (!el || !el.dataset.url) return;
    var load = function () {
      if (el.dataset.loaded) return;
      el.dataset.loaded = 'true';
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pdp-recommendations]');
          if (!fresh) return;
          el.replaceChildren();
          while (fresh.firstChild) { el.appendChild(fresh.firstChild); }
          var sw = el.querySelector('[data-pdp-rec-swiper]');
          if (sw && typeof Swiper !== 'undefined') {
            new Swiper(sw, {
              slidesPerView: 2.3,
              spaceBetween: 8,
              centerInsufficientSlides: true,
              navigation: { prevEl: el.querySelector('.rec-prev'), nextEl: el.querySelector('.rec-next') },
              breakpoints: {
                768: { slidesPerView: 3, spaceBetween: 16 },
                1024: { slidesPerView: 3.5, spaceBetween: 16 },
                1280: { slidesPerView: 4.5, spaceBetween: 16 },
                1536: { slidesPerView: 5.5, spaceBetween: 20 }
              }
            });
          }
        })
        .catch(function () { delete el.dataset.loaded; });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        io.disconnect();
        load();
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else {
      load();
    }
  }

  // Customer reels — slider + autoplay (muted) the reel currently in view.
  function initVideoReviews() {
    var sec = document.querySelector('[data-pdp-vr]');
    if (!sec) return;
    var sw = sec.querySelector('[data-pdp-vr-swiper]');
    var nav = sec.querySelector('[data-pdp-vr-nav]');
    if (sw && typeof Swiper !== 'undefined') {
      var swiper = new Swiper(sw, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centerInsufficientSlides: true,
        watchOverflow: true,
        navigation: { prevEl: sec.querySelector('.vr-prev'), nextEl: sec.querySelector('.vr-next') }
      });
      // Hide the arrows when every reel already fits (nothing to scroll).
      var syncNav = function () { if (nav) nav.style.display = swiper.isLocked ? 'none' : ''; };
      syncNav();
      swiper.on('lock', syncNav);
      swiper.on('unlock', syncNav);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var p = e.target.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            e.target.pause();
          }
        });
      }, { threshold: [0, 0.6, 1] });
      sec.querySelectorAll('[data-pdp-vr-video]').forEach(function (v) { io.observe(v); });
    }
  }

  // Sticky add-to-cart bar: reveal when the main buy box is out of view,
  // including above it on mobile. Its Add to cart drives the
  // real product form, reusing the cart bus + fly-to-cart. Image/price/state
  // stay in sync via the shared [data-pdp-*] hooks updated in apply().
  function initStickyBar() {
    var bar = root.querySelector('[data-pdp-sticky]');
    var buybox = root.querySelector('[data-pdp-buybox]');
    if (!bar || !buybox) return;

    var shown = false;
    var mobile = window.matchMedia('(max-width: 1023px)');
    bar.setAttribute('data-css-toggle', '');

    function show() {
      if (shown) return;
      shown = true;
      bar.setAttribute('data-state', 'shown');
      bar.setAttribute('aria-hidden', 'false');
      bar.removeAttribute('inert');
    }
    function hide() {
      if (!shown) return;
      shown = false;
      bar.setAttribute('data-state', 'hidden');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
    function update() {
      var rect = buybox.getBoundingClientRect();
      if (rect.bottom < 0 || (mobile.matches && rect.top >= window.innerHeight)) show();
      else hide();
    }

    var atc = bar.querySelector('[data-pdp-sticky-atc]');
    if (atc) {
      atc.addEventListener('click', function () {
        var form = document.getElementById('pdp-form');
        if (!form) return;
        form._cartSubmitter = atc;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () {
        update();
      }, { threshold: 0 });
      io.observe(buybox);
    }
    mobile.addEventListener('change', update);
    update();
  }

  // Breadcrumb share button: native share sheet where available, otherwise copy
  // the page URL to the clipboard and flash the "copied" tooltip.
  function initShare() {
    root.querySelectorAll('[data-pdp-share]').forEach(function (btn) {
      var feedback = btn.querySelector('[data-pdp-share-feedback]');
      var timer;

      function flash() {
        if (!feedback) return;
        feedback.setAttribute('data-show', '');
        clearTimeout(timer);
        timer = setTimeout(function () { feedback.removeAttribute('data-show'); }, 1600);
      }

      function copy(url) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(flash).catch(function () {});
          return;
        }
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); flash(); } catch (e) {}
        document.body.removeChild(ta);
      }

      btn.addEventListener('click', function () {
        var url = window.location.href;
        var title = btn.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        copy(url);
      });
    });
  }

  // Arrow-driven snap slider: left/right arrows scroll the native snap track,
  // disabling (and fading) themselves at each end. The track itself scrolls on
  // touch/trackpad; the arrows give desktop users — who have no visible scrollbar
  // and can't drag the video controls — a way to page through.
  function wireArrowSlider(slider, prev, next) {
    if (!slider) return;
    function step() { return Math.max(slider.clientWidth * 0.8, 200); }
    function update() {
      var max = slider.scrollWidth - slider.clientWidth - 1;
      if (prev) prev.disabled = slider.scrollLeft <= 0;
      if (next) next.disabled = slider.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // PDP collection product slider.
  function initCollectionSlider() {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll('[data-pdp-coll]').forEach(function (wrap) {
      var el = wrap.querySelector('.pdp-coll-swiper');
      if (!el || el.dataset.inited) return;
      el.dataset.inited = '1';
      new Swiper(el, {
        slidesPerView: 2.3,
        spaceBetween: 5,
        centerInsufficientSlides: true,
        speed: 600,
        grabCursor: true,
        navigation: {
          prevEl: wrap.querySelector('.pdp-coll-prev'),
          nextEl: wrap.querySelector('.pdp-coll-next'),
        },
        breakpoints: {
          640: { slidesPerView: 2.5, spaceBetween: 10 },
          768: { slidesPerView: 3.1, spaceBetween: 12 },
          1024: { slidesPerView: 3.2, spaceBetween: 13 },
        },
      });
    });
  }

  // Customer reels slider — same arrow-driven snap track as the collection band.
  function initReelsSlider() {
    root.querySelectorAll('[data-pdp-reels]').forEach(function (wrap) {
      wireArrowSlider(
        wrap.querySelector('[data-pdp-reels-slider]'),
        wrap.querySelector('[data-pdp-reels-prev]'),
        wrap.querySelector('[data-pdp-reels-next]')
      );
    });
  }

  function boot() {
    try { window.__pdpMain = initGallery(); } catch (e) { console.error('[PDP] initGallery failed:', e); }
    try { initZoom(); } catch (e) { console.error('[PDP] initZoom failed:', e); }
    try { initVariants(); } catch (e) { console.error('[PDP] initVariants failed:', e); }
    try { initShare(); } catch (e) { console.error('[PDP] initShare failed:', e); }
    try { initCollectionSlider(); } catch (e) { console.error('[PDP] initCollectionSlider failed:', e); }
    try { initReelsSlider(); } catch (e) { console.error('[PDP] initReelsSlider failed:', e); }
    try { initQuantity(); } catch (e) { console.error('[PDP] initQuantity failed:', e); }
    try { initQtyTiers(); } catch (e) { console.error('[PDP] initQtyTiers failed:', e); }
    try { initStickyBar(); } catch (e) { console.error('[PDP] initStickyBar failed:', e); }
    try { initDescription(); } catch (e) { console.error('[PDP] initDescription failed:', e); }
    try { initVideoReviews(); } catch (e) { console.error('[PDP] initVideoReviews failed:', e); }
    try { initRecommendations(); } catch (e) { console.error('[PDP] initRecommendations failed:', e); }
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot, { once: true });
})();
